module.exports = __webpack_public_path__ + "img/Marc-Trepanier.8e4aa4f0.png";